import React, { useState, useEffect } from 'react';
import { Tabs, Table, EditOutlined, DeleteFilled, Button,message, Popconfirm, PlusOutlined, useSelector, useDispatch, Tooltip,PlusSquareOutlined,Skeleton,AuditOutlined,ReconciliationOutlined,Spin } from '../AntComponent';
import AddSettings from './modal/AddSettings';
import { useNavigate,useLocation } from 'react-router-dom';
import { deleteProjectRole, deleteProjectType, deleteSponsor, getProjectRole, getProjectType, getSponsorDetails,getProjectMethod,deleteProjectMethod } from '../../store/actions/project-management/ProjectSettingAction';
import TemplateDetail from './TemplateDetail';
import { getMilestone } from '../../store/actions/project-management/ProjectAction';

export default function ProjectSettings() {
    const { profileInfo } = useSelector(state => state.userPrf);
    const tenantID = profileInfo?.data?.appUser?.tenantID;
    const appUserID = profileInfo?.data?.appUser?.appuserID;
    const locationID = profileInfo?.data?.location[0]?.locationID;
    const [showDetail, setShowDetail] = useState(false);
    const callbackFunc = (item) => {
        setShowDetail(item);
    } 
    const [selectedTab, setSelectedTab] = useState('1');
    const items1 = [
        // {
        //     key: "1",
        //     label: <><AuditOutlined/><span>Project Method</span></>,
        //     children: <ProjectMethod data={{ tenantID: tenantID, locationID: locationID, appUserID: appUserID }} />
        // },
        {
            key: "1",
            label: <><AuditOutlined/><span>Project Type</span></>,
            children: <ProjectType data={{ tenantID: tenantID, locationID: locationID, appUserID: appUserID,callbackFunc: callbackFunc, showDetail:showDetail }} />
        },
        {
            key: "2",
            label: <><ReconciliationOutlined/><span>Project Template</span></>,
            children: <TemplateDetail data={{appUserID: appUserID, tenantID: tenantID, locationID: locationID, tabKey: selectedTab,
                }}/>
        },
        // {
        //     key: "3",
        //     label: "Project Role",
        //     children: <ProjectRole data={{ tenantID: tenantID, locationID: locationID, appUserID: appUserID }} />
        // },
        // {
        //     key: "4",
        //     label: "Sponsor Details",
        //     children: <SponsorDetails data={{ tenantID: tenantID, locationID: locationID, appUserID: appUserID }} />
        // },
       

    ];

    const handleTabChange = (key) => {
        setSelectedTab(key);
    };

    return (
        <div>
            <div className='mb-2 rounded'>
                <h5>Project Settings</h5>
            </div>
            <div className=' rounded h-100 stock-tabcontainers'>
                <Tabs className='projectSet-tabs'
                    defaultActiveKey='1'
                    items={items1}
                    onChange={handleTabChange}
                />
            </div>
        </div>
    )
}

function ProjectType(props) {
    const dispatch = useDispatch();
    const history = useNavigate();
    const tenantID = props.data.tenantID;
    const locationID = props.data.locationID;
    const appUserID = props.data.appUserID;
    const { typeList,success11,deleteProjType,loading } = useSelector(state => state.projectSetting);
    const [initiativeTypeID, setInitiativeTypeID] = useState(0);
    const data = typeList ? typeList?.data : [];
    const [openDrawer, setOpenDrawer] = useState(false);
    const [rowData, setRowData] = useState([]);
    const [showTypeDeletemsg, setTypeDeletemsg] = useState(false);
    const Typedeletemsg = showTypeDeletemsg ? success11 : null;
    const [openUpload, setOpenUpload] = useState(false);
    useEffect(()=>{
        if (Typedeletemsg) {
            if(deleteProjType?.data?.msg =="Deleted Successfully"){
                message.success("Project Type Deleted Successfully");
                setTypeDeletemsg(false);
            }
            else{
                message.warning(deleteProjType?.data?.msg);
                setTypeDeletemsg(false);
            }
        }
    },[Typedeletemsg])
    const delProjectType=(tid)=>{
        let id = `${tenantID}/${tid}`
        dispatch(deleteProjectType(id));
        setTypeDeletemsg(true);
        const timer = setTimeout(() => {
            getProjectTypeList();
        }, 1000);
        return () => clearTimeout(timer);
        }
    const columns = [
        {
            title: 'Project Type',
            dataIndex: 'initiativeType',
            key: 'initiativeType',
            render: (text) => <a>{text}</a>,
        },
        {
            title: 'Description',
            dataIndex: 'description',
            key: 'description',
        },
        {
            title: 'Status',
            dataIndex: 'initiativeTypeStatus',
            key: 'initiativeTypeStatus',
        },

        {
            title: 'Action',
            key: 'action',
            render: (id, record) => (
                <div size="middle">
                    <Tooltip title="Edit Project Type" className='mt-0'>
                        <EditOutlined onClick={() => { setRowData(record); setOpenDrawer(true) }} />
                    </Tooltip>
                    <Popconfirm
                        // title="Delet"
                        description="Are you sure to delete this project type?"
                        onConfirm={()=>delProjectType(record.initiativeTypeID)}
                        // onCancel={cancel}
                        okText="Yes"
                        cancelText="No"
                    >
                        <span><Tooltip title="Delete Project Type" className='mt-0'><DeleteFilled className="text-danger ms-1 me-1" /></Tooltip></span> 
                    </Popconfirm>
                    {/* <Tooltip title="Add Project Template" className='mt-0 me-1'>
                        <PlusSquareOutlined onClick={() => {setRowData(record); setInitiativeTypeID(record.initiativeTypeID);props.data.callbackFunc(true);}} />
                    </Tooltip> */}
                </div>
            ),
        },
    ];

    const handleOpenDrawer = () => {
        setOpenDrawer(true);
        setRowData(null);
    }

    const drawerCallbackFunc = (item) => {
        setOpenDrawer(item);
    }
    function getProjectTypeList() {
        if (props.data.tenantID) {
            let ids = `${tenantID}/${locationID}/0`;
            dispatch(getProjectType(ids));
        }
    }
    useEffect(() => {
        getProjectTypeList();
    }, [dispatch, props.data.tenantID]);

    const handleCancel = () => { 
        setOpenUpload(false);
    };

    return (
        <>
        {
            !props.data.showDetail ?
            <div className=''>
                <div className='row ps-4 pe-3 pt-3'>
                    <h6 className='col-auto mb-0'>List of Project Types</h6>
                    <div className='col-auto ms-auto d-flex mb-2'>
                    <Tooltip title="Add Project Type" className='mt-0'>
                        <Button type='primary' className='tbl-btn col-auto px-2 py-0' icon={<PlusOutlined />}
                            onClick={handleOpenDrawer}>
                            Add
                        </Button>
                    </Tooltip>
                    </div>
                </div>
                {
                    <Spin spinning={loading}>
                        <Table className="entitlement-table" rowKey="initiativeTypeID" columns={columns} dataSource={data} />
                    </Spin>
                }
                <AddSettings data={{
                    title: "Add/Update Project Type", isOpen: openDrawer, id: 2, drawerCallbackFunc: drawerCallbackFunc,
                    tenantID: tenantID, appUserID: appUserID, locationID: locationID, rowData:rowData, callbackFunc: getProjectTypeList
                }} />
            </div> 
            : <TemplateDetail data={{appUserID: appUserID, tenantID: tenantID, locationID: locationID,initiativeTypeID: initiativeTypeID,
                drawerCallbackFunc: drawerCallbackFunc,callbackFuncs:props.data.callbackFunc,rowData:rowData,callbackFunc: getProjectTypeList }}/>
        }
        </>
        
    )
}

function ProjectRole(props) {
    const dispatch = useDispatch();
    const { roleList, success8,deleteProjRole } = useSelector(state => state.projectSetting);
    const data = roleList ? roleList?.data : [];
    const tenantID = props.data.tenantID;
    const locationID = props.data.locationID;
    const appUserID = props.data.appUserID;
    const [openDrawer, setOpenDrawer] = useState(false);
    const [rowData, setRowData] = useState([]);
    const [showRoleDeletemsg, setRoleDeletemsg] = useState(false);
    const roledeletemsg = showRoleDeletemsg ? success8 : null;

    useEffect(() => {
        if (roledeletemsg) {
            if(deleteProjRole?.data?.msg =="Deleted Successfully"){
                message.success("Project Role Deleted Successfully");
                setRoleDeletemsg(false);
            }
            else{
                message.warning(deleteProjRole?.data?.msg)
                setRoleDeletemsg(false);
            }
        }
    }, [roledeletemsg]);

    const delProjRole=(rid)=>{
        let id = `${tenantID}/${rid}`
        dispatch(deleteProjectRole(id));
        setRoleDeletemsg(true);
        const timer = setTimeout(() => {
           getProjectRoleList();
       }, 1000);
       return () => clearTimeout(timer);
     }
    const columns = [
        {
            title: 'Project Role',
            dataIndex: 'projectRole',
            key: 'projectRole',
            render: (text) => <a>{text}</a>,
        },
        {
            title: 'Description',
            dataIndex: 'description',
            key: 'description',
        },
        {
            title: 'Status',
            dataIndex: 'roleStatus',
            key: 'roleStatus',
        },

        {
            title: 'Action',
            key: 'action',
            render: (id, record) => (
                <div size="middle">
                    <Tooltip title="Edit Project Role" className='mt-0'>
                        <EditOutlined onClick={() => { setRowData(record); setOpenDrawer(true) }} />
                    </Tooltip>
                    <Tooltip title="Delete Project Role" className='mt-0'>
                        <Popconfirm
                            description="Are you sure to delete this project role?"
                            onConfirm={()=>delProjRole(record.projectRoleID)}
                            okText="Yes"
                            cancelText="No"
                        >
                            <DeleteFilled className="text-danger ms-1" />
                        </Popconfirm>
                    </Tooltip>
                </div>
            ),
        },
    ]; 

    const handleOpenDrawer = () => {
        setOpenDrawer(true);
        setRowData(null);
    }

    const drawerCallbackFunc = (item) => {
        setOpenDrawer(item);
    }
    function getProjectRoleList() {
        if (props.data.tenantID) {
            let ids = `${props.data.tenantID}/${props.data.locationID}/0`;
            dispatch(getProjectRole(ids));
        }
    }
    useEffect(() => {
        getProjectRoleList();
    }, [dispatch, props.data.tenantID]);

    return (
        <div className='p-3'>
            <div className='row'>
                <h6 className='col-auto mb-0'>List of Project Roles</h6>
                <div className='col-auto ms-auto d-flex mb-2'>
                <Tooltip title="Add Project Role" className='mt-0'>
                    <Button type='primary' className='tbl-btn col-auto px-2 pb-1' icon={<PlusOutlined />}
                        onClick={handleOpenDrawer}>Add</Button>
                </Tooltip>
                </div>
            </div>
            <Table rowKey="projectRoleID" columns={columns} dataSource={data} />
            <AddSettings data={{
                title: "Add/Update Project Role", isOpen: openDrawer, id: 3, drawerCallbackFunc: drawerCallbackFunc,
                callbackFunc: getProjectRoleList, rowData:rowData,tenantID: tenantID, appUserID: appUserID, locationID: locationID,
            }} />
        </div>
    )
}

function SponsorDetails(props) {
    const dispatch = useDispatch();
    const tenantID = props.data.tenantID;
    const locationID = props.data.locationID;
    const appUserID = props.data.appUserID;
    const { sponsorList,success13,deleteSponsorList } = useSelector(state => state.projectSetting);
    const data = sponsorList ? sponsorList?.data : [];
    const [openDrawer, setOpenDrawer] = useState(false);
    const [rowData, setRowData] = useState([]);
    const [showSponserDeletemsg, setSponserDeletemsg] = useState(false);
    const sponserdeletemsg = showSponserDeletemsg ? success13 : null;

    useEffect(() => {
        if (sponserdeletemsg) {
            if(deleteSponsorList?.data?.msg =="Deleted Successfully"){
                message.success(" Sponsor Detail Deleted Successfully");
                setSponserDeletemsg(false);
            }
            else{
                message.warning(deleteSponsorList?.data?.msg)
                setSponserDeletemsg(false);
            }
        }
    }, [sponserdeletemsg]);
    const deleteProjSponsor=(id)=>{
        dispatch(deleteSponsor(id));
        setSponserDeletemsg(true);
        const timer = setTimeout(() => {
            getProjectRoleList();
        }, 1000);
        return () => clearTimeout(timer);
      
     }

    const columns = [
        {
            title: 'Sponsor Name',
            dataIndex: 'sponsorName',
            key: 'sponsorName',
            render: (text) => <a>{text}</a>,
        },
        {
            title: 'Sponsor Short Name',
            dataIndex: 'shortName',
            key: 'shortName',
        },
        {
            title: "Description",
            dataIndex: "description",
            key: "description"
        },
        {
            title: 'Status',
            dataIndex: 'clientStatus',
            key: 'clientStatus',
        },

        {
            title: 'Action',
            key: 'action',
            render: (id, record) => (
                <div size="middle">
                    <EditOutlined onClick={() => { setRowData(record); setOpenDrawer(true) }} />
                    <Popconfirm
                        description="Are you sure to delete this project sponsor?"
                        onConfirm={()=>deleteProjSponsor(record.sponsorID)}
                        okText="Yes"
                        cancelText="No"
                    >
                        <DeleteFilled className="text-danger ms-1" />
                    </Popconfirm>
                </div>
            ),
        },
    ];

    const handleOpenDrawer = () => {
        setOpenDrawer(true);
        setRowData(null);
    }

    const drawerCallbackFunc = (item) => {
        setOpenDrawer(item);
    }

    function getProjectRoleList() {
        if (props.data.tenantID) {
            let ids = `${tenantID}/${locationID}/0`;
            dispatch(getSponsorDetails(ids));
        }
    }

    useEffect(() => {
        getProjectRoleList();
    }, [dispatch, props.data.tenantID]);


    return (
        <div className='p-3'>
            <div className='row'>
                <h6 className='col-auto mb-0'>List of Sponsor Details</h6>
                <div className='col-auto ms-auto d-flex mb-2'>
                    <Button type='primary' className='tbl-btn col-auto px-2 pb-1' icon={<PlusOutlined />}
                        onClick={handleOpenDrawer}>Add</Button>
                </div>
            </div>
            <Table rowKey="sponsorID" columns={columns} dataSource={data} />
            <AddSettings data={{
                title: "Add/Update Sponsor Details", isOpen: openDrawer, id: 4, drawerCallbackFunc: drawerCallbackFunc,
                tenantID: tenantID, appUserID: appUserID, locationID: locationID, callbackFunc: getProjectRoleList,rowData:rowData
            }} />
        </div>
    )
}

function ProjectMethod(props) {
    const dispatch = useDispatch();
    const tenantID = props.data.tenantID;
    const locationID = props.data.locationID;
    const appUserID = props.data.appUserID;
    const { methodList, success10,deleteProjMethod } = useSelector(state => state.projectSetting);
    const data = methodList ? methodList?.data : [];
    const [openDrawer, setOpenDrawer] = useState(false);
    const [rowData, setRowData] = useState([]);
    const [showMethodDeletemsg, setMethodDeletemsg] = useState(false);
    const methoddeletemsg = showMethodDeletemsg ? success10 : null;

    useEffect(()=>{
         if (methoddeletemsg) {
            if(deleteProjMethod?.data?.msg =="Deleted Successfully"){
                message.success("Project Method Deleted Successfully");
                setMethodDeletemsg(false);
            }
            else{
                message.warning(deleteProjMethod?.data?.msg);
                setMethodDeletemsg(false);
            }
        }
    },[methoddeletemsg])
    const delProjMethod=(mid)=>{
        let id = `${tenantID}/${mid}`
        dispatch(deleteProjectMethod(id));
        setMethodDeletemsg(true);
        const timer = setTimeout(() => {
            getProjectMethodList();
        }, 1000);
        return () => clearTimeout(timer);
    }
    const columns = [
        {
            title: 'Method Name',
            dataIndex: 'methodName',
            key: 'methodType',
            render: (text) => <a>{text}</a>,
        },
        {
            title: 'Description',
            dataIndex: 'description',
            key: 'description',
        },
        {
            title: 'Status',
            dataIndex: 'methodStatus',
            key: 'methodStatus',
        },

        {
            title: 'Action',
            key: 'action',
            render: (id, record) => (
                <div size="middle">
                    <Tooltip title="Edit Project Method" className='mt-0'>
                        <EditOutlined onClick={() => { setRowData(record); setOpenDrawer(true) }} />
                    </Tooltip>
                    
                        <Popconfirm
                            // title="Delet"
                            description="Are you sure to delete this project method?"
                            onConfirm={()=>delProjMethod(record.proMethodID)}
                            // onCancel={cancel}
                            okText="Yes"
                            cancelText="No"
                        >
                           <span><Tooltip title="Delete Project Method" className='mt-0'><DeleteFilled className="text-danger ms-1" /></Tooltip></span>
                        </Popconfirm>
                    
                </div>
            ),
        },
    ];

    const handleOpenDrawer = () => {
        setOpenDrawer(true);
        setRowData(null);
    }

    const drawerCallbackFunc = (item) => {
        setOpenDrawer(item);
    }

    function getProjectMethodList() {
        if (props.data.tenantID) {
            let ids = `${tenantID}/0`;
            dispatch(getProjectMethod(ids));
        }
    }

    useEffect(() => {
        getProjectMethodList();
    }, [dispatch, props.data.tenantID]);


    return (
        <div className=''>
            <div className='row ps-4 pe-3 pt-3'>
                <h6 className='col-auto mb-0'>List of Project Methods</h6>
                <div className='col-auto ms-auto d-flex mb-2'>
                <Tooltip title="Add Project Method" className='mt-0'>
                    <Button type='primary' className='tbl-btn col-auto px-2 pb-1' icon={<PlusOutlined />}
                        onClick={handleOpenDrawer}>Add</Button>
                </Tooltip>
                </div>
            </div>
            <Table className="entitlement-table" rowKey="proMethodID" columns={columns} dataSource={data} />
            <AddSettings data={{
                title: "Add/Update Project Method", isOpen: openDrawer, id: 1, drawerCallbackFunc: drawerCallbackFunc,
                tenantID: tenantID, appUserID: appUserID, locationID: locationID, callbackFunc: getProjectMethodList,rowData:rowData
            }} />
        </div>
    )
}